export default ".no-bold {\n  font-weight: 400;\n}\n\n.optionChecked {\n  font-weight: normal !important;\n}\n";